// apps/lc/src/mocks/wireframe/dateUtils.ts
// Pure date utilities — no fixture imports (avoids circular deps)

const TODAY_ISO = '2026-05-13T00:00:00.000Z'

export function today(): Date {
  return new Date(TODAY_ISO)
}

export function daysAgo(n: number): Date {
  const d = today()
  d.setUTCDate(d.getUTCDate() - n)
  return d
}

export function formatDate(d: Date | string): string {
  const date = typeof d === 'string' ? new Date(d) : d
  return date.toISOString().slice(0, 10)
}

export function formatKRW(n: number): string {
  return `₩${n.toLocaleString('ko-KR')}`
}
